import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './security-compliance-assessments.css'

const SecurityComplianceAssessments = (props) => {
  return (
    <div className="security-compliance-assessments-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="Security-Compliance-Assessments - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/security-compliance-assessments"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-section">
        <div className="hero-media-layer">
          <img
            alt="Cybersecurity expert analyzing data"
            src="https://images.pexels.com/photos/5380594/pexels-photo-5380594.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="hero-background-image"
          />
        </div>
        <div className="hero-overlay"></div>
        <div className="security-compliance---assessments-hero-content-wrapper">
          <div className="security-compliance---assessments-hero-content hero-content">
            <div className="security-compliance---assessments-hero-badge">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
              <span>Enterprise-Grade Compliance</span>
            </div>
            <h1 className="hero-title security-compliance---assessments-hero-title">
              Security Compliance &amp; Assessments
            </h1>
            <p className="security-compliance---assessments-hero-subtitle hero-subtitle">
              Comprehensive gap assessments, controls mapping, and remediation
              planning across global standards. Achieve audit readiness with
              Cysigil Security&apos;s expert-led compliance framework.
            </p>
            <div className="security-compliance---assessments-hero-trust-signals">
              <div className="trust-signal-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>ISO Certified</span>
              </div>
              <div className="trust-signal-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>SOC 2 Experts</span>
              </div>
              <div className="trust-signal-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>PCI-DSS Compliant</span>
              </div>
            </div>
            <div className="hero-cta-group security-compliance---assessments-hero-cta-group">
              <a href="#contact">
                <div className="btn-primary btn btn-lg">
                  <span>Request Assessment</span>
                </div>
              </a>
              <a href="#services">
                <div className="btn btn-lg btn-outline">
                  <span>Our Services</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="features-intro-section">
        <div className="features-intro-container">
          <div className="features-intro-header">
            <h2 className="section-title">
              Comprehensive Compliance Framework
            </h2>
            <p className="section-subtitle">
              Our structured approach to gap assessments, controls mapping, and
              remediation planning ensures your organization meets global
              security standards with confidence.
            </p>
          </div>
          <div className="features-intro-grid">
            <div className="feature-intro-card">
              <div className="feature-intro-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m21 21l-4.34-4.34"></path>
                    <circle r="8" cx="11" cy="11"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="feature-intro-title">Gap Assessments</h3>
              <p className="feature-intro-description">
                Identify compliance gaps across ISO, SOC, PCI-DSS, and AI GRC
                standards with detailed analysis and prioritized recommendations
                for immediate action.
              </p>
            </div>
            <div className="feature-intro-card">
              <div className="feature-intro-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0zm.894.211v15M9 3.236v15"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="feature-intro-title">Controls Mapping</h3>
              <p className="feature-intro-description">
                Map your existing controls to industry frameworks with
                precision. Visualize coverage, identify overlaps, and streamline
                compliance across multiple standards.
              </p>
            </div>
            <div className="feature-intro-card">
              <div className="feature-intro-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="8" y="2" rx="1" ry="1" width="8" height="4"></rect>
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                  </g>
                </svg>
              </div>
              <h3 className="feature-intro-title">Remediation Planning</h3>
              <p className="feature-intro-description">
                Receive actionable roadmaps with prioritized remediation steps,
                resource allocation guidance, and timelines tailored to your
                organizational risk profile.
              </p>
            </div>
            <div className="feature-intro-card">
              <div className="feature-intro-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="feature-intro-title">Audit Readiness</h3>
              <p className="feature-intro-description">
                Prepare for audits with confidence through pre-audit
                assessments, evidence collection support, and comprehensive
                documentation aligned to auditor requirements.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="standards-timeline-section">
        <div className="standards-timeline-wrapper">
          <div className="standards-timeline-header">
            <h2 className="section-title">
              Standards Coverage &amp; Engagement Mapping
            </h2>
            <p className="section-subtitle">
              Comprehensive framework mapping across global security and
              compliance standards
            </p>
          </div>
          <div className="standards-timeline-track">
            <div className="security-compliance---assessments-timeline-item">
              <div className="security-compliance---assessments-timeline-marker">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="security-compliance---assessments-timeline-content">
                <h3 className="security-compliance---assessments-timeline-title">
                  ISO 27001
                </h3>
                <p className="security-compliance---assessments-timeline-description">
                  Information security management system certification with 114
                  controls mapping
                </p>
                <div className="timeline-tags">
                  <span className="timeline-tag">Gap Analysis</span>
                  <span className="timeline-tag">Implementation</span>
                </div>
              </div>
            </div>
            <div className="security-compliance---assessments-timeline-item">
              <div className="security-compliance---assessments-timeline-marker">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="security-compliance---assessments-timeline-content">
                <h3 className="security-compliance---assessments-timeline-title">
                  SOC 2 Type II
                </h3>
                <p className="security-compliance---assessments-timeline-description">
                  Trust service criteria assessment covering security,
                  availability, and confidentiality
                </p>
                <div className="timeline-tags">
                  <span className="timeline-tag">Readiness</span>
                  <span className="timeline-tag">Audit Support</span>
                </div>
              </div>
            </div>
            <div className="security-compliance---assessments-timeline-item">
              <div className="security-compliance---assessments-timeline-marker">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="security-compliance---assessments-timeline-content">
                <h3 className="security-compliance---assessments-timeline-title">
                  PCI-DSS v4.0
                </h3>
                <p className="security-compliance---assessments-timeline-description">
                  Payment card industry data security standard compliance for
                  cardholder data environments
                </p>
                <div className="timeline-tags">
                  <span className="timeline-tag">Scoping</span>
                  <span className="timeline-tag">Remediation</span>
                </div>
              </div>
            </div>
            <div className="security-compliance---assessments-timeline-item">
              <div className="security-compliance---assessments-timeline-marker">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="security-compliance---assessments-timeline-content">
                <h3 className="security-compliance---assessments-timeline-title">
                  AI GRC
                </h3>
                <p className="security-compliance---assessments-timeline-description">
                  AI governance, risk, and compliance framework for responsible
                  AI deployment
                </p>
                <div className="timeline-tags">
                  <span className="timeline-tag">Risk Assessment</span>
                  <span className="timeline-tag">Framework</span>
                </div>
              </div>
            </div>
            <div className="security-compliance---assessments-timeline-item">
              <div className="security-compliance---assessments-timeline-marker">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="security-compliance---assessments-timeline-content">
                <h3 className="security-compliance---assessments-timeline-title">
                  GDPR / CCPA
                </h3>
                <p className="security-compliance---assessments-timeline-description">
                  Data protection and privacy compliance for global regulatory
                  requirements
                </p>
                <div className="timeline-tags">
                  <span className="timeline-tag">Privacy Impact</span>
                  <span className="timeline-tag">Controls</span>
                </div>
              </div>
            </div>
            <div className="security-compliance---assessments-timeline-item">
              <div className="security-compliance---assessments-timeline-marker">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="security-compliance---assessments-timeline-content">
                <h3 className="security-compliance---assessments-timeline-title">
                  NIST CSF
                </h3>
                <p className="security-compliance---assessments-timeline-description">
                  Cybersecurity framework alignment for risk management and
                  resilience
                </p>
                <div className="timeline-tags">
                  <span className="timeline-tag">Maturity</span>
                  <span className="timeline-tag">Mapping</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="security-compliance---assessments-methodology-section">
        <div className="methodology-container">
          <div className="security-compliance---assessments-methodology-header">
            <h2 className="section-title">Our Compliance Methodology</h2>
            <p className="section-subtitle">
              A proven, structured approach to identifying gaps, mapping
              controls, and planning remediation for lasting compliance success
            </p>
          </div>
          <div className="security-compliance---assessments-methodology-steps">
            <div className="security-compliance---assessments-methodology-step">
              <div className="security-compliance---assessments-step-number">
                <span>01</span>
              </div>
              <div className="security-compliance---assessments-step-content">
                <h3 className="step-title">Problem Statement</h3>
                <p className="step-description">
                  Organizations struggle with fragmented compliance approaches,
                  unclear control mappings, and inefficient audit preparation.
                  Multiple frameworks create complexity, leading to duplicated
                  efforts and compliance gaps that put certifications and
                  business operations at risk.
                </p>
              </div>
              <div className="security-compliance---assessments-step-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m21 21l-4.34-4.34"></path>
                    <circle r="8" cx="11" cy="11"></circle>
                  </g>
                </svg>
              </div>
            </div>
            <div className="security-compliance---assessments-methodology-step">
              <div className="security-compliance---assessments-step-number">
                <span>02</span>
              </div>
              <div className="security-compliance---assessments-step-content">
                <h3 className="step-title">Our Approach</h3>
                <p className="step-description">
                  We employ a unified assessment framework that maps controls
                  across multiple standards simultaneously. Our methodology
                  combines automated scanning, manual validation, and expert
                  analysis to deliver comprehensive gap assessments with
                  actionable insights tailored to your risk profile and business
                  objectives.
                </p>
              </div>
              <div className="security-compliance---assessments-step-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0zm.894.211v15M9 3.236v15"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
            <div className="security-compliance---assessments-methodology-step">
              <div className="security-compliance---assessments-step-number">
                <span>03</span>
              </div>
              <div className="security-compliance---assessments-step-content">
                <h3 className="step-title">Deliverables</h3>
                <p className="step-description">
                  Receive detailed gap assessment reports, comprehensive
                  controls mapping matrices, prioritized remediation roadmaps
                  with timelines, policy templates, evidence collection guides,
                  and executive summaries. All documentation is audit-ready and
                  designed to accelerate your compliance journey from assessment
                  to certification.
                </p>
              </div>
              <div className="security-compliance---assessments-step-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="gap-services-section">
        <div className="gap-services-container">
          <div className="gap-services-header">
            <h2 className="section-title">Gap Assessment Services</h2>
            <p className="section-subtitle">
              Detailed engagement offerings for benchmarking, audit readiness,
              and comprehensive gap analysis
            </p>
          </div>
          <div className="gap-services-grid">
            <div className="gap-service-card">
              <div className="gap-service-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="8" cx="11" cy="11"></circle>
                    <path d="m21 21l-4.3-4.3M11 7v4m0 4h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="gap-service-title">Current State Assessment</h3>
              <p className="gap-service-description">
                Comprehensive evaluation of existing security controls,
                policies, and procedures against target compliance frameworks to
                establish baseline maturity.
              </p>
            </div>
            <div className="gap-service-card">
              <div className="gap-service-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="gap-service-title">Control Gap Identification</h3>
              <p className="gap-service-description">
                Detailed analysis identifying missing, inadequate, or
                non-compliant controls with risk ratings and impact assessments
                for prioritization.
              </p>
            </div>
            <div className="gap-service-card">
              <div className="gap-service-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0zm.894.211v15M9 3.236v15"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="gap-service-title">Benchmarking Analysis</h3>
              <p className="gap-service-description">
                Compare your security posture against industry peers and best
                practices to understand relative maturity and competitive
                positioning.
              </p>
            </div>
            <div className="gap-service-card">
              <div className="gap-service-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5m-10 4.5L8 15l2 2.5m4-5l2 2.5l-2 2.5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="gap-service-title">Evidence Review</h3>
              <p className="gap-service-description">
                Systematic review of existing documentation, policies, and
                artifacts to validate control effectiveness and identify
                documentation gaps for audit readiness.
              </p>
            </div>
            <div className="gap-service-card">
              <div className="gap-service-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="8" y="2" rx="1" ry="1" width="8" height="4"></rect>
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    <path d="m9 14l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="gap-service-title">Pre-Audit Readiness Check</h3>
              <p className="gap-service-description">
                Mock audit simulation to identify potential audit findings
                before formal assessment, including documentation completeness
                and control testing validation.
              </p>
            </div>
            <div className="gap-service-card">
              <div className="gap-service-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m5 12l7-7l7 7m-7 7V5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="gap-service-title">Maturity Assessment</h3>
              <p className="gap-service-description">
                Evaluate your security program maturity across multiple
                dimensions using industry-standard frameworks to chart a path
                toward continuous improvement and optimization.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="remediation-process-section">
        <div className="remediation-process-container">
          <div className="remediation-process-header">
            <h2 className="section-title">
              Controls Mapping &amp; Remediation Roadmap
            </h2>
            <p className="section-subtitle">
              Structured framework for mapping existing controls to compliance
              requirements and executing prioritized remediation with clear
              timelines
            </p>
          </div>
          <div className="remediation-process-steps">
            <div className="remediation-step">
              <div className="remediation-step-marker">
                <span className="remediation-step-number">01</span>
              </div>
              <div className="remediation-step-content">
                <h3 className="remediation-step-title">
                  Control Inventory &amp; Discovery
                </h3>
                <p className="remediation-step-description">
                  Catalog all existing security controls across technical,
                  administrative, and physical domains. Identify control
                  ownership, implementation status, and operational
                  effectiveness through stakeholder interviews and documentation
                  review.
                </p>
                <div className="remediation-step-timeline">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M16 14v2.2l1.6 1M16 4h2a2 2 0 0 1 2 2v.832M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2"></path>
                      <circle r="6" cx="16" cy="16"></circle>
                      <rect x="8" y="2" rx="1" width="8" height="4"></rect>
                    </g>
                  </svg>
                  <span>Week 1-2</span>
                </div>
              </div>
            </div>
            <div className="remediation-step">
              <div className="remediation-step-marker">
                <span className="remediation-step-number">02</span>
              </div>
              <div className="remediation-step-content">
                <h3 className="remediation-step-title">
                  Framework Mapping Analysis
                </h3>
                <p className="remediation-step-description">
                  Map discovered controls to target framework requirements (ISO
                  27001, SOC 2, PCI-DSS, etc.). Identify control overlaps across
                  multiple standards to optimize compliance efforts and reduce
                  duplication.
                </p>
                <div className="remediation-step-timeline">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M16 14v2.2l1.6 1M16 4h2a2 2 0 0 1 2 2v.832M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2"></path>
                      <circle r="6" cx="16" cy="16"></circle>
                      <rect x="8" y="2" rx="1" width="8" height="4"></rect>
                    </g>
                  </svg>
                  <span>Week 3-4</span>
                </div>
              </div>
            </div>
            <div className="remediation-step">
              <div className="remediation-step-marker">
                <span className="remediation-step-number">03</span>
              </div>
              <div className="remediation-step-content">
                <h3 className="remediation-step-title">
                  Gap Prioritization &amp; Risk Scoring
                </h3>
                <p className="remediation-step-description">
                  Assign risk ratings to identified gaps based on likelihood,
                  impact, and regulatory importance. Create prioritized
                  remediation matrix aligned with business risk tolerance and
                  resource constraints.
                </p>
                <div className="remediation-step-timeline">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M16 14v2.2l1.6 1M16 4h2a2 2 0 0 1 2 2v.832M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2"></path>
                      <circle r="6" cx="16" cy="16"></circle>
                      <rect x="8" y="2" rx="1" width="8" height="4"></rect>
                    </g>
                  </svg>
                  <span>Week 5</span>
                </div>
              </div>
            </div>
            <div className="remediation-step">
              <div className="remediation-step-marker">
                <span className="remediation-step-number">04</span>
              </div>
              <div className="remediation-step-content">
                <h3 className="remediation-step-title">
                  Remediation Roadmap Development
                </h3>
                <p className="remediation-step-description">
                  Design phased remediation plan with quick wins, medium-term
                  projects, and long-term strategic initiatives. Define resource
                  requirements, dependencies, and success criteria for each
                  remediation task.
                </p>
                <div className="remediation-step-timeline">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M16 14v2.2l1.6 1M16 4h2a2 2 0 0 1 2 2v.832M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2"></path>
                      <circle r="6" cx="16" cy="16"></circle>
                      <rect x="8" y="2" rx="1" width="8" height="4"></rect>
                    </g>
                  </svg>
                  <span>Week 6-7</span>
                </div>
              </div>
            </div>
            <div className="remediation-step">
              <div className="remediation-step-marker">
                <span className="remediation-step-number">05</span>
              </div>
              <div className="remediation-step-content">
                <h3 className="remediation-step-title">
                  Implementation Support &amp; Validation
                </h3>
                <p className="remediation-step-description">
                  Provide ongoing guidance during remediation execution.
                  Validate implemented controls through testing and
                  documentation review. Track progress against milestones and
                  adjust roadmap as needed for audit readiness.
                </p>
                <div className="remediation-step-timeline">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M16 14v2.2l1.6 1M16 4h2a2 2 0 0 1 2 2v.832M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2"></path>
                      <circle r="6" cx="16" cy="16"></circle>
                      <rect x="8" y="2" rx="1" width="8" height="4"></rect>
                    </g>
                  </svg>
                  <span>Week 8+</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="standards-stats-section">
        <div className="standards-stats-container">
          <div className="standards-stats-header">
            <h2 className="section-title">
              Compliance Standards &amp; Framework Coverage
            </h2>
            <p className="section-subtitle">
              Comprehensive mapping of relevant security standards with direct
              service alignment
            </p>
          </div>
          <div className="standards-stats-grid">
            <div className="standard-stat-card">
              <div className="standard-stat-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="standard-stat-number">
                <span>ISO 27001</span>
              </div>
              <h3 className="standard-stat-title">
                Information Security Management
              </h3>
              <p className="standard-stat-description">
                114 controls across 14 domains for comprehensive ISMS
                certification
              </p>
              <div className="standard-stat-services">
                <span>Gap Analysis, Implementation, Audit Support</span>
              </div>
            </div>
            <div className="standard-stat-card">
              <div className="standard-stat-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="standard-stat-number">
                <span>SOC 2</span>
              </div>
              <h3 className="standard-stat-title">Trust Service Criteria</h3>
              <p className="standard-stat-description">
                Type I &amp; Type II assessments covering 5 trust service
                principles
              </p>
              <div className="standard-stat-services">
                <span>
                  Readiness Assessment, Control Testing, Report Preparation
                </span>
              </div>
            </div>
            <div className="standard-stat-card">
              <div className="standard-stat-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="standard-stat-number">
                <span>PCI-DSS</span>
              </div>
              <h3 className="standard-stat-title">
                Payment Card Data Security
              </h3>
              <p className="standard-stat-description">
                12 requirements for cardholder data environment protection
              </p>
              <div className="standard-stat-services">
                <span>Scoping, Gap Assessment, Remediation Planning</span>
              </div>
            </div>
            <div className="standard-stat-card">
              <div className="standard-stat-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="standard-stat-number">
                <span>AI GRC</span>
              </div>
              <h3 className="standard-stat-title">AI Governance &amp; Risk</h3>
              <p className="standard-stat-description">
                Responsible AI deployment with risk-based governance framework
              </p>
              <div className="standard-stat-services">
                <span>
                  Risk Assessment, Policy Development, Model Validation
                </span>
              </div>
            </div>
            <div className="standard-stat-card">
              <div className="standard-stat-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="standard-stat-number">
                <span>NIST CSF</span>
              </div>
              <h3 className="standard-stat-title">Cybersecurity Framework</h3>
              <p className="standard-stat-description">
                Risk management framework across Identify, Protect, Detect,
                Respond, Recover
              </p>
              <div className="standard-stat-services">
                <span>
                  Maturity Assessment, Framework Mapping, Implementation
                </span>
              </div>
            </div>
            <div className="standard-stat-card">
              <div className="standard-stat-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="standard-stat-number">
                <span>GDPR</span>
              </div>
              <h3 className="standard-stat-title">
                Data Protection Regulation
              </h3>
              <p className="standard-stat-description">
                Privacy compliance with 7 principles and individual rights
                protection
              </p>
              <div className="standard-stat-services">
                <span>
                  Privacy Impact Assessment, Controls Implementation, DPO
                  Support
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="cta-section security-compliance---assessments-cta-section">
        <div className="cta-wrapper security-compliance---assessments-cta-wrapper">
          <div className="security-compliance---assessments-cta-content-left">
            <div className="cta-icon-wrapper">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
            </div>
            <h2 className="security-compliance---assessments-cta-title">
              <a className="btn-primary btn btn-lg" href="https://outlook.office.com/book/CysigilNetwork@cysigil.com/?ismsaljsauthenabled">
                <span>Talk to an Expert</span>
              </a>
            </h2>
            <p className="security-compliance---assessments-cta-description">
              Schedule a consultation with our compliance specialists to discuss
              your gap assessment needs and receive a customized roadmap for
              achieving certification.
            </p>
            <a href="#contact">
              <div className="btn-primary btn-xl btn">
                <span>Schedule Consultation</span>
              </div>
            </a>
          </div>
          <div className="security-compliance---assessments-cta-content-right">
            <div className="cta-icon-wrapper">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="8" y="2" rx="1" ry="1" width="8" height="4"></rect>
                  <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                  <path d="m9 14l2 2l4-4"></path>
                </g>
              </svg>
            </div>
            <h2 className="security-compliance---assessments-cta-title">
              Request Assessment
            </h2>
            <p className="security-compliance---assessments-cta-description">
              Get a comprehensive compliance gap assessment tailored to your
              industry and target frameworks. Receive actionable insights within
              2 weeks.
            </p>
            <a href="#request">
              <div className="btn-xl btn-accent btn">
                <span>Request Assessment</span>
              </div>
            </a>
          </div>
        </div>
      </section>
      <div className="security-compliance-assessments-container2">
        <div className="security-compliance-assessments-container3">
          <Script
            html={`<script defer data-name="scroll-animations">
(function(){
  const observerOptions = {
    threshold: 0.15,
    rootMargin: "0px 0px -50px 0px",
  }

  const animateOnScroll = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1"
        entry.target.style.transform = "translateY(0)"
      }
    })
  }, observerOptions)

  const elementsToAnimate = document.querySelectorAll(".feature-intro-card, .timeline-item, .methodology-step, .gap-service-card, .remediation-step, .standard-stat-card")

  elementsToAnimate.forEach((el, index) => {
    el.style.opacity = "0"
    el.style.transform = "translateY(30px)"
    el.style.transition = \`opacity 0.6s ease \${index * 0.1}s, transform 0.6s ease \${index * 0.1}s\`
    animateOnScroll.observe(el)
  })

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    elementsToAnimate.forEach((el) => {
      el.style.opacity = "1"
      el.style.transform = "none"
      el.style.transition = "none"
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default SecurityComplianceAssessments
